import React, { useState }   from 'react'
import { useNavigate } from 'react-router-dom'
import { useUser } from '../../../store/UserContext'

function DebugNav() {
    const navigate=useNavigate()
    const { currentUser, userData } = useUser();
   

    
    const [isOpen, setIsOpen] = useState(false); // State to manage mobile menu visibility
    const [isDropdownOpen, setIsDropdownOpen] = useState(false); // State to manage dropdown visibility
  
    // Function to toggle the mobile menu
    const toggleMenu = () => {
      setIsOpen(!isOpen);
      // Close dropdown if mobile menu is closing
      if (isOpen) {
        setIsDropdownOpen(false);
      }
    };
  
    // Function to toggle the dropdown menu
    const toggleDropdown = () => {
      setIsDropdownOpen(!isDropdownOpen);
    };
  
    // Function to close the dropdown
    const closeDropdown = () => {
      setIsDropdownOpen(false);
    };
  
  return (
    <header className="bg-gradient-to-r from-indigo-600 to-purple-700 shadow-xl font-sans relative z-10 ">
    <div className="container mx-auto px-4 py-4 flex items-center justify-between">
      {/* Logo Section */}
      <div className="flex items-center">
        <a href="#" className="text-3xl font-extrabold text-white hover:text-yellow-300 transition-colors duration-300 transform hover:scale-105">
          Fashion Loop<span className="text-yellow-300">.In <sub >&#174;</sub></span>
        </a>
      </div>

      {/* Desktop Navigation */}
      <nav className="hidden md:flex space-x-8 items-center">
        <a href="#" className="text-white hover:text-yellow-300 text-lg font-medium transition-colors duration-300 relative group" onClick={()=>{navigate('/admin-home');}}>
          Dashboard
          <span className="absolute left-0 bottom-0 w-0 h-0.5 bg-yellow-300 transition-all duration-300 group-hover:w-full"></span>
        </a>

        <a href="#" className="text-white hover:text-yellow-300 text-lg font-medium transition-colors duration-300 relative group" onClick={()=>{navigate('/add-products');}}>
          Add Products
          <span className="absolute left-0 bottom-0 w-0 h-0.5 bg-yellow-300 transition-all duration-300 group-hover:w-full"></span>
        </a>

        <a href="#" className="text-white hover:text-yellow-300 text-lg font-medium transition-colors duration-300 relative group" onClick={()=>{navigate('/orders-all');}}>
          All Orders
          <span className="absolute left-0 bottom-0 w-0 h-0.5 bg-yellow-300 transition-all duration-300 group-hover:w-full"></span>
        </a>
         <a href="#" className="text-white hover:text-yellow-300 text-lg font-medium transition-colors duration-300 relative group" onClick={()=>{navigate('/all-users');}}>
          All Users
          <span className="absolute left-0 bottom-0 w-0 h-0.5 bg-yellow-300 transition-all duration-300 group-hover:w-full"></span>
        </a>
        <a href="#" className="text-white hover:text-yellow-300 text-lg font-medium transition-colors duration-300 relative group" onClick={()=>{navigate('/get-about-us');}}>
          Get About Us    
          <span className="absolute left-0 bottom-0 w-0 h-0.5 bg-yellow-300 transition-all duration-300 group-hover:w-full"></span>
        </a>
        <a href="#" className="text-white hover:text-yellow-300 text-lg font-medium transition-colors duration-300 relative group" >
        Logged As:  <span className='text-yellow-300'> {currentUser?.displayName} </span>  
          <span className="absolute left-0 bottom-0 w-0 h-0.5 bg-yellow-300 transition-all duration-300 group-hover:w-full"></span>
        </a>
        <a href="#" className="text-white hover:text-yellow-300 text-lg font-medium transition-colors duration-300 relative group" onClick={()=>{navigate('/');}}>
          User Page   
          <span className="absolute left-0 bottom-0 w-0 h-0.5 bg-yellow-300 transition-all duration-300 group-hover:w-full"></span>
        </a>
 
      </nav>

      {/* Mobile Menu Button (Hamburger Icon) */}
      <div className="md:hidden flex items-center">
        <button
          onClick={toggleMenu}
          className="text-white hover:text-yellow-300 focus:outline-none focus:ring-2 focus:ring-yellow-300 rounded-md p-2 transition-colors duration-300"
          aria-label="Toggle menu"
        >
          {/* Hamburger Icon */}
          <svg
            className="w-8 h-8"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            {isOpen ? (
              // Close icon (X)
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M6 18L18 6M6 6l12 12"
              ></path>
            ) : (
              // Hamburger icon
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M4 6h16M4 12h16m-7 6h7"
              ></path>
            )}
          </svg>
        </button>
      </div>
    </div>

    {/* Mobile Navigation (Conditional Rendering) */}
    {isOpen && (
      <nav className="md:hidden bg-indigo-700 border-t border-indigo-600 py-4 animate-fade-in-down">
        <div className="flex flex-col items-center space-y-4">
          <a href="#" className="text-white hover:text-yellow-300 text-lg font-medium transition-colors duration-300 w-full text-center py-3 rounded-md hover:bg-indigo-600" onClick={()=>{navigate('/admin-home');}}>
              Dashboard 
          </a>
          <a href="#" className="text-white hover:text-yellow-300 text-lg font-medium transition-colors duration-300 w-full text-center py-3 rounded-md hover:bg-indigo-600" onClick={()=>{navigate('/add-products');}}>
            Add Products
          </a>
          <a href="#" className="text-white hover:text-yellow-300 text-lg font-medium transition-colors duration-300 w-full text-center py-3 rounded-md hover:bg-indigo-600" onClick={()=>{navigate('/orders-all');}}>
                All Orders
          </a>
          <a href="#" className="text-white hover:text-yellow-300 text-lg font-medium transition-colors duration-300 w-full text-center py-3 rounded-md hover:bg-indigo-600" onClick={()=>{navigate('/all-users');}}>
            All Users
          </a>
          <a href="#" className="text-white hover:text-yellow-300 text-lg font-medium transition-colors duration-300 w-full text-center py-3 rounded-md hover:bg-indigo-600" onClick={()=>{navigate('/get-about-us');}}>
            Get About Us
          </a>
          <a href="#" className="text-white hover:text-yellow-300 text-lg font-medium transition-colors duration-300 w-full text-center py-3 rounded-md hover:bg-indigo-600" >
            Logged As: <span className='text-yellow-300'> {currentUser?.displayName} </span>
          </a>
          <a href="#" className="text-white hover:text-yellow-300 text-lg font-medium transition-colors duration-300 w-full text-center py-3 rounded-md hover:bg-indigo-600" onClick={()=>{navigate('/');}}>
            User Page
          </a>

         
        </div>
      </nav>
    )}
  </header>
  )
}

export default DebugNav